import VSLayout from './VSLayout'

export default VSLayout
